export class Individual {
  static combineName(supervisor) {
    if (!supervisor) return null;
    const { first_name, surname, patronymic } = supervisor;
    const parts = [surname, first_name, patronymic];

    return parts.filter((p) => p).join(' ');
  }
}
